/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

/**
 * Returns a language's name in the given UI language via `Intl.DisplayNames`
 * (for example `de` -> "German" for an English UI). Shared by the Viewer
 * language picker and the Editor language select so both name languages the
 * same way.
 *
 * @param languageCode - Language code to name (for example: en, de).
 * @param uiLanguage - UI language to name it in; falls back to `en` when empty.
 * @returns The display name, the uppercase code if the runtime cannot name it,
 *   or an empty string when no code is given.
 */
export function languageDisplayName(
  languageCode: string | undefined | null,
  uiLanguage: string | undefined | null,
): string {
  if (!languageCode) {
    return '';
  }
  try {
    return (
      new Intl.DisplayNames([uiLanguage || 'en'], {type: 'language'}).of(
        languageCode,
      ) ?? languageCode.toUpperCase()
    );
  } catch {
    return languageCode.toUpperCase();
  }
}
